import {ReactNode} from 'react'

type Props = {
    children: ReactNode
}

export default function RowHeader({children}: Props) {
    return (
        <th
            scope="row"
            className="text-left pl-4 border-gray-5 text-gray-21 h-[54px] w-[220px] whitespace-pre border-t-[1px]">
            {children}
        </th>
    )
}
